module.exports = __webpack_public_path__ + "static/img/thumb-at-risk.9acfc95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-at-risk.png
// module id = 83
// module chunks = 0